import { EMPTY_PROFILE, type Profile } from '../../../shared/profile.ts'

/**
 * Локальное хранилище — источник правды для офлайна.
 * Бэкенд синхронизирует те же поля, но приложение работает и без него.
 */

const KEY = 'sirr.v1'

/**
 * Форма профиля и чистые действия над ней — общие, в `shared/profile.ts`:
 * копии у web и натива уже начали расходиться. Здесь остаётся только то, чем
 * платформы действительно отличаются, — само хранилище.
 *
 * Пере-экспорт нужен, чтобы вызывающий код не переписывать: он и так берёт
 * `Profile`, `EMPTY_PROFILE` и прочее отсюда.
 */
export {
  EMPTY_PROFILE,
  bumpStreak,
  sameDraw,
  type AskLine,
  type BirthInput,
  type DrawnCard,
  type Profile,
  type ReadingRecord,
} from '../../../shared/profile.ts'

/**
 * Было ли приложение уже запущено на этом устройстве.
 *
 * Отдельная функция, потому что от этого зависит выбор языка, и решать это
 * в двух местах по-разному нельзя: у пустого профиля язык уже проставлен
 * умолчанием, и проверка «взять сохранённый, иначе настройку Telegram» молча
 * давала бы это умолчание всем новым людям вместо их собственного языка.
 */
export function hasStoredProfile(): boolean {
  try {
    return localStorage.getItem(KEY) !== null
  } catch {
    return false
  }
}

export function loadProfile(): Profile {
  try {
    const raw = localStorage.getItem(KEY)
    if (!raw) return { ...EMPTY_PROFILE }
    return { ...EMPTY_PROFILE, ...(JSON.parse(raw) as Partial<Profile>) }
  } catch {
    return { ...EMPTY_PROFILE }
  }
}

export function saveProfile(p: Profile): void {
  try {
    localStorage.setItem(KEY, JSON.stringify(p))
  } catch {
    /* приватный режим / переполнение — не критично, работаем в памяти */
  }
}
